import React, { useState } from 'react';
import { GridApi } from '@instinet-analytics/semantic-ui-components';
import { OutliersData } from 'widgets/outliers/data/outliersData';
import { OutliersGridToolbar } from 'widgets/outliers/components/grid/OutliersGridToolbar';
import { OutliersGrid } from 'widgets/outliers/components/grid/OutliersGrid';
import { useOutliersConfigSlice } from 'widgets/outliers/store/config/configSlice';
import styleConstants from 'styles/variables.module.scss';
import './OutliersGridPanel.scss';
import { useOutlierWidgetDimensions } from 'widgets/outliers/components/hooks';
const padding = parseInt(styleConstants.spaceAround);
const toolbarHeight = parseInt(styleConstants.panelHeaderHeight);

export interface OutliersGridPanelProps {
    data?: OutliersData;
    selectedOrderIds: string[];
    highlightedOrderIds: string[];
    onlyShowSelected: boolean;
    onSetSelectedOrderIds: (ids: string[]) => void;
    onOnlyShowSelectedChanged: (next: boolean) => void;
}

export function OutliersGridPanel(props: OutliersGridPanelProps) {
    const { onOnlyShowSelectedChanged, onlyShowSelected, selectedOrderIds } =
        props;
    const { dockablePanelWidth: width, dockablePanelHeight: height } =
        useOutlierWidgetDimensions();

    const { config } = useOutliersConfigSlice();
    const { hideGridToolbar } = config;

    const [gridApi, setGridApi] = useState<GridApi | undefined>();

    const toolbarConsumedHeight = hideGridToolbar ? 0 : toolbarHeight;
    const gridHeight = height - padding - toolbarConsumedHeight;

    const style = {
        height: `${height}px`,
        width: `${width}px`,
    };

    return (
        <div className="OutliersGridPanel" style={style}>
            <OutliersGridToolbar
                gridApi={gridApi}
                onOnlyShowSelectedChanged={onOnlyShowSelectedChanged}
                onlyShowSelected={onlyShowSelected}
                selectedOrderIds={selectedOrderIds}
            />
            <OutliersGrid
                {...props}
                onGridApiSet={setGridApi}
                height={gridHeight}
            />
        </div>
    );
}
